// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__+xikX","block":"footer_block__36yMX"};